import React from "react";
import {EditElementModalForm} from "../../EditElementModalForm";
import {MultiSelect} from "../../selects/MultiSelect";
import {Spinner} from "../../Spinner";
import { withTranslation } from 'react-i18next';

export class SelectItemsMultiSelectModalForm extends EditElementModalForm {

    constructor(props) {
        super(props);
        this.state = {
            items: this.getItems(),
            saving: false,
            selectedItems: []
        };

        this.onItemsChange = this.onItemsChange.bind(this);
        this.handleRefreshItemsList = this.handleRefreshItemsList.bind(this);
    }

    componentDidUpdate(prevProps) {
        // compare new prop value with previous one
        const prevItems = this.getItems(prevProps);
        const newItems = this.getItems();


        if (this.props.isLoadingInactiveItems !== prevProps.isLoadingInactiveItems || !this._ItemListsHasNoDifference(newItems, prevItems)) {
            this.setState({
                ...this.state,
                items: this.getItems()
            })
        }
    }

    _ItemListsHasNoDifference(list1, list2) {
        if (list1 === undefined && list2 === undefined)
            return true;

        if (list1 !== undefined && list2 === undefined || list1 === undefined && list2 !== undefined)
            return false;

        // Sort the lists
        const sortedList1 = list1.sort((a, b) => a.id - b.id);
        const sortedList2 = list2.sort((a, b) => a.id - b.id);

        // Convert the lists to strings
        const strList1 = JSON.stringify(sortedList1);
        const strList2 = JSON.stringify(sortedList2);

        // Compare the strings
        return strList1 === strList2;
    }

    getItems(props=null){
        throw Error("Must override");
    }

    onItemsChange(data) {
        this.setState({
            selectedItems: data
        });
    }

    handleRefreshItemsList() {
        this.props.onRefreshItemsList();
    }

    renderSaveButton() {
        if (this.state.saving === false) {
            return <input type="submit" value={this.addItemsButtonText()} className="btn -submit"/>
        } else {
            return <Spinner color="positive small"/>;
        }
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({saving: false});
        this.props.onModified(this.state.selectedItems);

    }

    renderFormFields() {
        const { t } = this.props;
        const items = this.getItems();
        const onLoadInactiveItems = this.props.onLoadInactiveItems !== undefined ? this.props.onLoadInactiveItems : null;

        if (items !== null) {
            if (items.length > 0) {
                return (<div className="form-row">
                    <MultiSelect
                        longList={true}
                        showOnlyActiveInitialStatus={true}
                        items={items}
                        selectedItemIds={this.state.selectedItems}
                        onChange={this.onItemsChange}
                        showOnlyActiveCheck={true}
                        isUpdatingListItems={this.props.isUpdatingListItems}
                        messageForRefreshListItemsIconToolbox={this.props.messageForRefreshListItemsIconToolbox}
                        onRefreshListItems={this.props.onRefreshListItems}
                        onLoadInactiveItems={onLoadInactiveItems}
                        inactiveItemsAreLoaded={this.props.inactiveItemsAreLoaded}
                        isLoadingInactiveItems={this.props.isLoadingInactiveItems}
                    /></div>
                )
            } else {
                return <p>{this.noItemsText()}</p>
            }
        } else {
            return <p>{t('common.loading')}</p>;
        }
    }

    noItemsText() {
        throw Error("Must override");
    }

    addItemsButtonText() {
        throw Error("Must override");
    }

}

class SelectCampaignsMultiSelectModalFormComponent extends SelectItemsMultiSelectModalForm {
    noItemsText() {
        const { t } = this.props;
        return t('select_items.no_campaigns');
    }

    addItemsButtonText() {
        const { t } = this.props;
        return t('select_items.add_campaigns');
    }

    getItems(props=null){
        return props === null ? this.props.campaigns : props.campaigns;
    }
}

class SelectAdgroupsMultiSelectModalFormComponent extends SelectItemsMultiSelectModalForm {
    noItemsText() {
        const { t } = this.props;
        return t('select_items.no_adgroups');
    }

    addItemsButtonText() {
        const { t } = this.props;
        return t('select_items.add_adgroups');
    }

    getItems(props=null){
        props = props === null ? this.props : props;

        return props.adgroups.map(adgroup => {
            const item = {...adgroup};
            item.name = `${adgroup.campaign_name} ➡️ ${adgroup.name}`;
            return item;
        });
    }
}

export const SelectCampaignsMultiSelectModalForm = withTranslation()(SelectCampaignsMultiSelectModalFormComponent);
export const SelectAdgroupsMultiSelectModalForm = withTranslation()(SelectAdgroupsMultiSelectModalFormComponent);